export default __webpack_public_path__ + "static/media/bias-score.ec1f9900.svg";